module.exports = __webpack_public_path__ + "media/images/ui__textArrowUp-80718a34781886eeb318240bdd3ccf26.png";